import React from 'react';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import WelcomeSection from './Welcome';
import Navbar from '../Company/About/Navbar';
import Footer from '../Company/About/Footer';

function ContactPage() {
  return (
    <div className="min-h-screen w-full bg-background">
      <Navbar />
      <WelcomeSection />
      <div className="w-full">
        <ContactInfo />
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
}

export default ContactPage;